export default __webpack_public_path__ + "static/media/storage-attic.077c507c.svg";